<template>
  <div
    class="modal-cancel-btn"
    :class="{ loading: isLoading, disabled: isDisabled }"
  >
    <div class="modal-cancel-title" @click="$emit('click')">
      <slot v-if="!isLoading" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'CancelButton',
  props: {
    isLoading: {
      type: Boolean,
      default: false,
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
  },
}
</script>
